import Splide from '@splidejs/splide';

jQuery(document).ready(function ($) {
  if ($('.testimonials-slider').length) {
    $('.testimonial-logo').each(function () {
      $(this).addClass('splide__slide');
    });

    $('.testimonials-slider').each(function () {
      // remove loading="lazy" attribute from any images
      $(this).find('img').removeAttr('loading');
    });

    var perPage = 1;
    if ($(window).width() > 420) perPage = 2;
    if ($(window).width() > 600) perPage = 3;
    if ($(window).width() > 640) perPage = 4;
    if ($(window).width() > 960) perPage = 5;

    const splideController = new Splide('.testimonials-slider', {
      type: 'loop',
      speed: 1000,
      autoplay: false,
      interval: 4000,
      perPage: perPage,
      arrows: false,
    }).mount();

    var Autoplay = splideController.Components.Autoplay;

    const animationClassNames = ['testimonials-slider'];

    const animations = [];

    animationClassNames.forEach((className) => {
      const items = document.querySelectorAll(`.${className}`);
      items.forEach((item) => animations.push(item));
    });

    const animationObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          const animation = entry.target;

          animationClassNames.forEach((className) => {
            if (animation.classList.contains(className)) {
              Autoplay.play();
            }
          });
        }
      });
    });

    animations.forEach((animation) => {
      animationObserver.observe(animation);
    });
  }

  if ($('.wc-block-grid').length) {
    $('.wc-block-grid').each(function () {
      $(this).addClass('splide');
    });

    $('.wc-block-grid__products').each(function () {
      $(this).addClass('splide__list');

      $(this).wrap("<div class='splide__track'>");
    });

    $('.wc-block-grid__product').each(function () {
      $(this).addClass('splide__slide');
    });

    var productsPerPage = 1;
    if ($(window).width() > 840) productsPerPage = 2;
    if ($(window).width() > 1100) productsPerPage = 3;

    var x = new Splide('.wc-block-grid', {
      type: 'slide',
      speed: 1000,
      autoplay: false,
      perPage: 1,
      arrows: false,
    }).mount();
  }
});
